// Indian Standard Time formatter — used across viewer, admin, watermark, audit log.
const IST_OPTS_FULL = {
  timeZone: "Asia/Kolkata",
  day: "2-digit", month: "short", year: "numeric",
  hour: "2-digit", minute: "2-digit", hour12: true,
};
const IST_OPTS_SHORT = {
  timeZone: "Asia/Kolkata",
  day: "2-digit", month: "short",
  hour: "2-digit", minute: "2-digit", hour12: true,
};
const IST_OPTS_DATE = {
  timeZone: "Asia/Kolkata",
  day: "2-digit", month: "short", year: "numeric",
};

export function formatIST(input, opts = "full") {
  if (!input) return "—";
  const d = typeof input === "string" || typeof input === "number" ? new Date(input) : input;
  if (isNaN(d.getTime())) return "—";
  const preset = opts === "short" ? IST_OPTS_SHORT : opts === "date" ? IST_OPTS_DATE : IST_OPTS_FULL;
  return d.toLocaleString("en-IN", preset) + " IST";
}

export function daysSinceISO(iso) {
  if (!iso) return Infinity;
  const then = new Date(iso).getTime();
  if (isNaN(then)) return Infinity;
  return (Date.now() - then) / (1000 * 60 * 60 * 24);
}

// Terms must be re-accepted every 15 days. Master admin is exempt (see App.js).
export function termsExpired() {
  const last = localStorage.getItem("cc_terms_agreed_at");
  return !last || daysSinceISO(last) > 15;
}
